import _each from "lodash/each";
import Menu from "~/js/common/menu";
import store from "~/js/store/store";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";

export default class Header {
  constructor() {
    this.view = document.querySelector(".l-header");
    this.menuCloseButton = document.querySelector(".js-menu-close");
    //ハンバーガーメニュー内のサイト内検索
    this.site_search = document.getElementById("menu_site_search");
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);
    if (this.view) {
      this.menuButton = this.view.querySelector(".js-navibutton");
    }
    this.setup();
    this.setupKeybord();
    this.setSiteSearch();
  }
  setup() {
    this.menu = new Menu();
    store.subscribe((mutation, state) => {
      if (mutation.type === "afterScroll") {
        this.updateBackground(state);
      } else if (mutation.type === "scrollInNavi" || mutation.type === "toggleNavi" || mutation.type === "closeNavi") {
        this.updateLogoVisible();
      } else if (mutation.type === "scrollY") {
        this.updateHeaderVisible();
      } else if (mutation.type === "shoppingBugUpdate") {
        this.updateShoppingBugNum(state)
      }
    });
    this.menuButton.addEventListener("click", (event) => {
      event.preventDefault();
      if (store.getters["isModalOpen"]()) {
        store.dispatch("closeModal");
      } else {
        store.dispatch("toggleNavi");
        const menuModal = document.querySelector("#shopify-section-header-global-menu");

        this.menuCloseButton?.focus();
        trapFocus(menuModal, this.menuCloseButton);
      }
    });

    this.menuCloseButton && this.menuCloseButton.addEventListener('click', (event) => {
      event.preventDefault();

      store.dispatch("closeModal");
      this.menuButton.focus();
    })
  }

  /**
   * キーボードによるメニュー開閉
   * TODO キーボードイベントまわりの実装再考（storeで行うか等）
   */
  setupKeybord() {
    window.addEventListener("keydown", (event) => {
      if (event.keyCode === 27 || event.code === "Escape") {
        // Escape
        store.dispatch("closeNavi");
        store.dispatch("closeModal");
      }
    });
  }

  /**
   * ヘッダーのアイコンまわりの色を変更
   */
  updateHeaderColor() {
    let section = store.state.app.pinSection.nextSection;
    if (!section) {
      return;
    }
    this.execHeaderColor(section.classList.contains("white"));
  }

  execHeaderColor(isWhite) {
    const mypageIcon = this.view.querySelector(".js-header-mypageicon");
    const onlinestoreIcon = this.view.querySelector(".js-header-onlinestoreicon");
    const onlinestoreText = this.view.querySelector(".js-header-onlinestoretext");
    const bagIcon = this.view.querySelector(".js-header-bagicon");

    if (isWhite) {
      bagIcon.classList.add("white");
      // if (mypageIcon) {
      //   mypageIcon.classList.add("white");
      // }
      if (onlinestoreIcon) {
        onlinestoreIcon.classList.add("white");
      }
      if (onlinestoreText) {
        onlinestoreText.classList.add("white");
      }
    } else {
      bagIcon.classList.remove("white");
      // if (mypageIcon) {
      //   mypageIcon.classList.remove("white");
      // }
      if (onlinestoreIcon) {
        onlinestoreIcon.classList.remove("white");
      }
      if (onlinestoreText) {
        onlinestoreText.classList.remove("white");
      }
    }
  }

  /**
   * ヘッダの背景透過状況の更新
   * @param state
   */
  updateBackground(state) {
    if (state.app.pinSection.nextIndex !== 0 && !state.app.isHome) {
      //headerの背景を消す
      this.hideHeaderBackground();
    } else {
      this.showHeaderBackground();
    }
  }

  /**
   * ヘッダーの背景を消す
   */
  hideHeaderBackground() {
    this.view.classList.add("chamaeleon");
  }

  showHeaderBackground() {
    this.view.classList.remove("chamaeleon");
  }

  /**
   * ロゴ表示の更新
   */
  updateLogoVisible() {
    // メニューオープン時にスクロールされている
    if (store.getters["isMenuOpen"] && store.state.app.scrollInNavi > 0) {
      this.view.classList.add("logo-hidden");
    } else {
      // 上記以外はロゴ表示
      this.view.classList.remove("logo-hidden");
    }
  }

  /**
   * 下層において、スクロールの方向によって表示・非表示を切り替える
   */
  updateHeaderVisible() {
    if (!this.view) {
      return;
    }
    if (store.state.app.isPinSection) {
      return;
    }
    if (store.state.app.scrollY < 160) {
      this.view.classList.remove("scrolled");
      this.view.classList.remove("under");
      return;
    } else {
      this.view.classList.add("under");
    }
    if (store.getters["isScrollDown"]) {
      this.view.classList.add("scrolled");
    } else {
      this.view.classList.remove("scrolled");
    }
  }

  setSiteSearch() {
    if (this.site_search) {
      //検索時に、tagを付与してsubmit
      this.site_search.addEventListener('submit', this.onSiteSearchSubmitHandler.bind(this));
    }
  }

  onSiteSearchSubmitHandler(evt) {
    evt.preventDefault();
    this.site_search.q.value = this.site_search.q.value+" "+this.site_search.free_word.value.replace(/　/g," ");
    this.site_search.submit()
  }

  updateShoppingBugNum(state){
    this.header__bag = this.view.querySelector(".l-header__bag");
    if(!this.header__bag){
      return;
    }
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        this.view.querySelector(".l-header__bag__count").textContent = data.item_count
        this.view.querySelector(".l-header__bag__count").classList.add("on")
        this.view.querySelector(".l-header__bag__count").insertAdjacentHTML ('beforeend', `<span class="visually-hidden">${data.item_count === 1 ? 'item' : 'items'} in cart</span>`)
      })
      .catch((e) => {
        console.error(e);
      })
  }

}
